import React from 'react';

import InitiateGoal from '../../components/goals/InitiateGoal';

const NewGoal = () => {
  return <InitiateGoal renderType="page" />;
};

export default NewGoal;
